export const projectsData = [
  {
    id: 1,
    projectName: "Frametile",
    projectDesc:
      "Dynamic Image Template Engine platform enabling teams to build, personalize, and render image/video overlays on the fly via REST APIs with folder permissions and IP whitelisting.",
    tags: [
      "React.js",
      "Node.js",
      "Express",
      "MongoDB",
      "REST API",
      "Tailwind CSS",
    ],
    code: "https://github.com/akkisavi",
    demo: "https://frametile.com/",
    image: "/img-studio.png",
  },
  {
    id: 2,
    projectName: "Kusuri Nonda",
    projectDesc:
      "Automated notification & escalation platform sending WhatsApp alerts with companion ESP8266 IoT hardware receiving instant audio-visual cues via Rails ActionCable WebSockets.",
    tags: [
      "Ruby on Rails",
      "Action Cable",
      "ESP8266 IoT",
      "React.js",
      "WhatsApp API",
    ],
    code: "https://github.com/akkisavi",
    demo: "https://kusurinonda.com/",
    image: "/kusurinonda.png",
  },
  {
    id: 3,
    projectName: "Online NDA Signing Platform",
    projectDesc:
      "Enterprise digital agreement workflow system reducing turnaround times from days to minutes using OTP authentication, digital signatures, and audit-ready contract vaults.",
    tags: ["React.js", "Node.js", "MySQL", "Digital Signatures", "OTP Auth"],
    code: "https://github.com/akkisavi",
    demo: "https://nda.fairshare.tech",
    image: "/nda.png",
  },
  {
    id: 4,
    projectName: "DataForge AI",
    projectDesc:
      "AI-powered data analytics platform enabling users to upload datasets, generate insights, and visualize results through an interactive conversational interface.",
    tags: [
      "React.js",
      "Python",
      "Deep Learning",
      "Data Analytics",
      "Machine Learning",
    ],
    code: "https://github.com/akkisavi",
    demo: "https://dataforge-ai-six.vercel.app/",
    image: "/dataforge.png",
  },
  {
    id: 5,
    projectName: "Industrial Thermal Source Detector",
    projectDesc:
      "AI-based pipeline that clusters NASA FIRMS thermal detections into persistent sources, classifies them (gas flare, kiln, smelter, wildfire, etc.) and flags unregistered facilities by cross-checking OSM and flare catalogs, with a GIS-ready map dashboard.",
    tags: [
      "Python",
      "FastAPI",
      "PostGIS",
      "LightGBM",
      "React.js",
      "MapLibre",
    ],
    code: "https://github.com/akkisavi",
    demo: "",
    image: "/hackathon.jpg",
    video: "/hackathon.mp4",
  },
];
